<template>
  <div>
    <div class="item-overlay">
      <a href="#" @click.prevent="$emit('add-to-playlist', item.id)">
        <div class="play-icon">
          <i :class="iconCls"></i>
        </div>
      </a>
    </div>

    <img :src="imgUrl" :alt="item.pagetitle" class="video-img" />

    <div class="video-info">
      <div class="series-tag" v-if="item.parent !== '10'">
        <img src="@/assets/images/seriesResultTag.png" alt="" />
        <span>סדרה</span>
      </div>
      <div class="series-tag" v-else>
        <img src="@/assets/images/Imunim.png" alt="" />
        <span>תוכנית</span>
      </div>
      <div>
        <current-tag
          :current="getCurrent"
          :base="this.$store.state.initialData.basepath"
        >
        </current-tag>
      </div>
      <level-icon :level="level"></level-icon>
    </div>
    <h4 class="video-item-h4">{{ item.pagetitle }}</h4>
    <div>
      <teacher-tag
        :teacher="getTeacher"
        :base="this.$store.state.initialData.basepath"
      >
      </teacher-tag>
    </div>
    <p class="description" v-html="abstract"></p>
    <div class="read-more">
      <svg style="width: 20px; height: 20px" viewBox="0 0 20 20">
        <path
          fill="currentColor"
          d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import TeacherTag from "@/components/TeacherTag_v2.vue";
import CurrentTag from "@/components/CurrentTag_v2.vue";
import LevelIcon from "@/components/levelIcon.vue";

export default {
  name: `VideoItem`,

  props: {
    item: Object,
  },
  components: {
    CurrentTag,
    TeacherTag,
    LevelIcon,
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.image;
    },
    getCurrent() {
      if (Array.isArray(this.$store.state.currents)) {
        const current = this.$store.state.currents.find(
          c =>
            typeof c.resource !== `undefined` &&
            c.resource.id === this.item.current
        );

        return current;
      }
      return {};
    },
    getTeacher() {
      const teacher = this.$store.state.initialData.teachers.find(
        t => t.id === this.item.teacher
      );
      if (teacher) {
        return teacher;
      }
      return { id: `` };
    },
    level() {
      if (this.$store.state.initialData.levels.length > 0) {
        const lvl = this.$store.state.initialData.levels.find(
          l => l.value === this.item.level
        );
        if (lvl) {
          return lvl;
        }
      }
      return { label: `` };
    },
    abstract() {
      const str = this.item.description;
      if (str.length > 150) {
        return `${str.slice(0, 150)}...`;
      }
      return str;
    },
    iconCls() {
      if (
        this.item.parent !== "10" &&
        this.$store.state.user.currentPlaylist.series.includes(this.item.id)
      ) {
        return "mdi mdi-check-circle is-selected";
      }
      if (
        this.item.parent === "10" &&
        this.$store.state.user.currentPlaylist.collections.includes(
          this.item.id
        )
      ) {
        return "mdi mdi-check-circle is-selected";
      }
      return "mdi mdi-check-circle";
    },
  },
};
</script>

<style lang="scss">
</style>
